import { Skeleton } from 'antd';
import React, { FC } from 'react';
import { TableSkeleton } from 'components/atoms/table';
import {
  BaseWidget,
  WidgetContainer,
  PageContentWrapper,
} from 'components/organisms/projects-report/common';

export const LoadingState: FC = () => (
  <PageContentWrapper>
    <WidgetContainer xs={24} md={12} lg={12} xl={8} xxl={6}>
      <BaseWidget>
        <BaseWidget.Content>
          <Skeleton
            title={false}
            paragraph={{ rows: 2, width: ['100%', '80%'] }}
          />
        </BaseWidget.Content>
      </BaseWidget>
      <BaseWidget>
        <BaseWidget.Content>
          <Skeleton
            title={false}
            paragraph={{ rows: 2, width: ['100%', '80%'] }}
          />
        </BaseWidget.Content>
      </BaseWidget>
    </WidgetContainer>
    <TableSkeleton columnCount={8} />
  </PageContentWrapper>
);
